import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { fmtEUR2, fmtDate } from "@/lib/format";

const dayDiff = (iso) => Math.round((new Date(`${iso}T00:00:00`) - new Date(new Date().toDateString())) / 86400000);
const when = (iso) => { const d = dayDiff(iso); return d < 0 ? `en retard de ${-d} j` : d === 0 ? "aujourd'hui" : d === 1 ? "demain" : `dans ${d} j`; };

export function InvoiceDueAlert() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/invoices/due-soon").then((r) => setData(r.data)).catch(() => setData(null)); }, []);
  if (!data?.items?.length) return null;
  const late = data.overdue > 0;
  return (
    <div data-testid="invoice-due-alert" className={`mt-5 rounded-3xl border p-4 sm:p-5 ${late ? "border-rose-100 bg-rose-50/70" : "border-amber-100 bg-amber-50/70"}`}>
      <div className="flex flex-wrap items-center gap-2">
        <CalendarClock className={`h-5 w-5 ${late ? "text-rose-600" : "text-amber-600"}`} />
        <p className={`mr-auto text-sm font-bold ${late ? "text-rose-800" : "text-amber-900"}`}>
          {data.items.length} facture(s) fournisseur à régler sous 7 jours{late ? `, dont ${data.overdue} en retard` : ""} · {fmtEUR2(data.total)}
        </p>
        <Link to="/factures" data-testid="invoice-due-link" className="flex items-center text-xs font-semibold text-[#065F46] hover:underline">Voir les factures<ChevronRight className="h-3.5 w-3.5" /></Link>
      </div>
      <ul className="mt-3 space-y-1.5">
        {data.items.slice(0, 5).map((r) => (
          <li key={r.id} data-testid={`invoice-due-${r.id}`} className="flex flex-wrap items-center gap-x-3 gap-y-0.5 rounded-2xl bg-white/80 px-3 py-2 text-sm">
            <span className="min-w-0 flex-1 basis-40 truncate font-medium">{r.supplier || r.original_filename}{r.invoice_number ? ` · n° ${r.invoice_number}` : ""}</span>
            <span className={`shrink-0 text-xs font-semibold ${dayDiff(r.due_date) < 0 ? "text-rose-600" : "text-amber-700"}`}>{fmtDate(r.due_date)} · {when(r.due_date)}</span>
            <span className="shrink-0 font-bold">{fmtEUR2(r.amount_ttc)}</span>
          </li>
        ))}
        {data.items.length > 5 && <li className="px-3 text-xs text-gray-500">+ {data.items.length - 5} autre(s)</li>}
      </ul>
    </div>
  );
}
